/* eslint-disable @next/next/no-img-element */
import { Button, Container, Typography } from '@pwskills/rachnaui';
import React, { useEffect } from 'react';
import Pw from '@pwskills/rachnaui/logo/Pw';
import { useRouter } from 'next/router';
import { isPwMedharthiDomain } from '@/utils/helper/helperFunction';

const ErrorPage = ({ isNotFound = true }: { isNotFound?: boolean }) => {
  const router = useRouter();

  useEffect(() => {
    const bodyEle = document.querySelector('body');
    if (bodyEle) bodyEle.style.marginTop = '0px';
  }, []);

  return (
    <>
      <nav className="bg-black">
        <Container className="py-4 medium:w-[85%] medium:m-auto large:w-[95%]">
          {!isPwMedharthiDomain && (
            <Pw
              className="cursor-pointer"
              onClick={() => {
                window.location.href = '/';
              }}
            />
          )}
        </Container>
      </nav>
      <Container className="flex flex-col items-center justify-center mt-14 gap-y-10">
        {isNotFound && (
          <Typography component="h1" variant="bold" className="text-center">
            Error <span className="text-orange-500"> 404!</span>
            <br />
            Page Not Found
          </Typography>
        )}
        <img src="/images/search-not-found.webp" alt="Not found" />
        <Typography component="body-regular">
          {isNotFound
            ? 'Please check your network connection and try again'
            : 'Something went wrong'}
        </Typography>
        <Button
          onClick={() => {
            if (isNotFound) {
              router.push('/');
            } else {
              router.reload();
            }
          }}
        >
          {isNotFound ? 'Go to Home' : 'Refresh'}
        </Button>
      </Container>
    </>
  );
};

export default ErrorPage;
